// In this example we try to create an enum that also contains resource keys

// Note: simply iterating CountriesEnum will give more entries
// Note: If we don't provide a each enum value will just be an index number

enum CommissionDepartmentsEnum {

    // These keys/values are used only for assignments
    // We didnt remove them because they said that it is possible oly to add a dg, not to update it
    AGRI = 'AGRI',
    BUDG = 'BUDG',
    CLIMA = 'CLIMA',
    CNECT = 'CNECT',
    COMM = 'COMM',
    COMP = 'COMP',
    DEFIS = 'DEFIS',
    INTPA = 'INTPA',
    DGT = 'DGT',
    DIGIT = 'DIGIT',
    EAC = 'EAC',
    ECFIN = 'ECFIN',
    ECHO = 'ECHO',
    EMPL = 'EMPL',
    ENER = 'ENER',
    ENEST = 'ENEST',
    ENV = 'ENV',
    EPSO = 'EPSO',
    ESTAT = 'ESTAT',
    FISMA = 'FISMA',
    FPI = 'FPI',
    GROW = 'GROW',
    HERA = 'HERA',
    HR = 'HR',
    IAS = 'IAS',
    IDEA = 'IDEA',
    JRC = 'JRC',
    JUST = 'JUST',
    MARE = 'MARE',
    MENA = 'MENA',
    MOVE = 'MOVE',
    NEAR = 'NEAR',
    OIB = 'OIB',
    OIL= 'OIL',
    OLAF = 'OLAF',
    OP = 'OP',
    REFORM = 'REFORM',
    REFOR = 'REFOR',
    REGIO = 'REGIO',
    HOME = 'HOME',
    PMO = 'PMO',
    RTD = 'RTD',
    SANTE = 'SANTE',
    SCIC = 'SCIC',
    SG = 'SG',
    SJ = 'SJ',
    TAXUD = 'TAXUD',
    TRADE = 'TRADE',
}

namespace CommissionDepartmentsEnum {

    type AdditionalFields = { resourceKey: string };
    export type Entry = { enumKey: string } & AdditionalFields;

    const fieldsMap: Map<CommissionDepartmentsEnum, AdditionalFields> = new Map(
        [
            [CommissionDepartmentsEnum.AGRI, {resourceKey: 'dg.AGRI'}],
            [CommissionDepartmentsEnum.BUDG, {resourceKey: 'dg.BUDG'}],
            [CommissionDepartmentsEnum.CLIMA, {resourceKey: 'dg.CLIMA'}],
            [CommissionDepartmentsEnum.CNECT, {resourceKey: 'dg.CNECT'}],
            [CommissionDepartmentsEnum.COMM, {resourceKey: 'dg.COMM'}],
            [CommissionDepartmentsEnum.COMP, {resourceKey: 'dg.COMP'}],
            [CommissionDepartmentsEnum.DEFIS, {resourceKey: 'dg.DEFIS'}],
            [CommissionDepartmentsEnum.DGT, {resourceKey: 'dg.DGT'}],
            [CommissionDepartmentsEnum.DIGIT, {resourceKey: 'dg.DIGIT'}],
            [CommissionDepartmentsEnum.EAC, {resourceKey: 'dg.EAC'}],
            [CommissionDepartmentsEnum.ECFIN, {resourceKey: 'dg.ECFIN'}],
            [CommissionDepartmentsEnum.ECHO, {resourceKey: 'dg.ECHO'}],
            [CommissionDepartmentsEnum.EMPL, {resourceKey: 'dg.EMPL'}],
            [CommissionDepartmentsEnum.ENER, {resourceKey: 'dg.ENER'}],
            [CommissionDepartmentsEnum.ENEST, {resourceKey: 'dg.ENEST'}],
            [CommissionDepartmentsEnum.ENV, {resourceKey: 'dg.ENV'}],
            [CommissionDepartmentsEnum.EPSO, {resourceKey: 'dg.EPSO'}],
            [CommissionDepartmentsEnum.ESTAT, {resourceKey: 'dg.ESTAT'}],
            [CommissionDepartmentsEnum.FISMA, {resourceKey: 'dg.FISMA'}],
            [CommissionDepartmentsEnum.FPI, {resourceKey: 'dg.FPI'}],
            [CommissionDepartmentsEnum.GROW, {resourceKey: 'dg.GROW'}],
            [CommissionDepartmentsEnum.HERA, {resourceKey: 'dg.HERA'}],
            [CommissionDepartmentsEnum.HOME, {resourceKey: 'dg.HOME'}],
            [CommissionDepartmentsEnum.HR, {resourceKey: 'dg.HR'}],
            [CommissionDepartmentsEnum.IAS, {resourceKey: 'dg.IAS'}],
            [CommissionDepartmentsEnum.IDEA, {resourceKey: 'dg.IDEA'}],
            [CommissionDepartmentsEnum.INTPA, {resourceKey: 'dg.INTPA'}],
            [CommissionDepartmentsEnum.JRC, {resourceKey: 'dg.JRC'}],
            [CommissionDepartmentsEnum.JUST, {resourceKey: 'dg.JUST'}],
            [CommissionDepartmentsEnum.MARE, {resourceKey: 'dg.MARE'}],
            [CommissionDepartmentsEnum.MENA, {resourceKey: 'dg.MENA'}],
            [CommissionDepartmentsEnum.MOVE, {resourceKey: 'dg.MOVE'}],
            [CommissionDepartmentsEnum.NEAR, {resourceKey: 'dg.NEAR'}],
            [CommissionDepartmentsEnum.OIB, {resourceKey: 'dg.OIB'}],
            [CommissionDepartmentsEnum.OIL, {resourceKey: 'dg.OIL'}],
            [CommissionDepartmentsEnum.OLAF, {resourceKey: 'dg.OLAF'}],
            [CommissionDepartmentsEnum.OP, {resourceKey: 'dg.OP'}],
            [CommissionDepartmentsEnum.PMO, {resourceKey: 'dg.PMO'}],
            [CommissionDepartmentsEnum.REFORM, {resourceKey: 'dg.REFORM'}],
            [CommissionDepartmentsEnum.REFOR, {resourceKey: 'dg.REFOR'}],
            [CommissionDepartmentsEnum.REGIO, {resourceKey: 'dg.REGIO'}],
            [CommissionDepartmentsEnum.RTD, {resourceKey: 'dg.RTD'}],
            [CommissionDepartmentsEnum.SANTE, {resourceKey: 'dg.SANTE'}],
            [CommissionDepartmentsEnum.SCIC, {resourceKey: 'dg.SCIC'}],
            [CommissionDepartmentsEnum.SG, {resourceKey: 'dg.SG'}],
            [CommissionDepartmentsEnum.SJ, {resourceKey: 'dg.SJ'}],
            [CommissionDepartmentsEnum.TAXUD, {resourceKey: 'dg.TAXUD'}],
            [CommissionDepartmentsEnum.TRADE, {resourceKey: 'dg.TRADE'}]
        ]);

    export let entries: Array<Entry> = [];

    /**
     * Function that is executed in the initialization of the angular app
     * in order to fetch the dgs from the database. In the old version the entrie
     * variable was initialized from the keys/values above, but from now on this variable
     * will be filled from the database in the start of the appliction
     * @param dgs
     */
    export function setCommissionDepartmentsSubj(dgs: Array<Entry>) {
        entries = dgs;
    }

    // values of the enumerator
    export const values: Array<CommissionDepartmentsEnum> = Array.from(fieldsMap.keys());

    /**
     * We create the translation for a given dg
     * @param e
     */
    export const resourceKey = (e: string): string => {
        return 'dg.' + e;
    };

    export const enumKey = (e: string): CommissionDepartmentsEnum => {
        const x = CommissionDepartmentsEnum.values.filter(v => v == e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        } // strictNullChecks require this
        return x[0];
    };
}

export { CommissionDepartmentsEnum };
